import axios from 'axios';
import contentDisposition from 'content-disposition';
import errorHandlerFactory from './errorHandler';

const errorHandler = errorHandlerFactory('An error occured when downloading CRIF.');

// eslint-disable-next-line import/prefer-default-export
export const downloadCrif = (runDate = null, csaID = null) => axios.get(`/csa/crifdownload${runDate ? `?runDate=${runDate}` : ''}${csaID ? `&csa=${csaID}` : ''}`)
    .then((r) => {
        const parsedContentDisposition = r.headers['content-disposition'] && contentDisposition.parse(r.headers['content-disposition']);
        return { data: r.data, filename: parsedContentDisposition.parameters.filename };
    }).catch(errorHandler);
